import * as ReselectModule from "reselect";
import { INotificationListState } from ".";
import { IApplicationState } from "..";

export const selectNotificationList: ReselectModule.Selector<
  IApplicationState,
  INotificationListState
> = (state) => state.notificationList;
